import { Card, CardContent } from '@/components/ui/card';
import filterIcon from '@/v2/assets/images/select-filter-icon.png';
import SelectFilterInfoCard from './SelectFilterInfoCard';
export default function KtServicesExplanation() {
  const imageUrl = filterIcon; // fallback only
  return (
    <div className="flex justify-center mt-4">
      <div className="w-full md:w-2/5">
        <div className="grid grid-cols-1 md:grid-cols-1 gap-6">
          {/* Left side */}
          <SelectFilterInfoCard />
        </div>
      </div>
    </div>
  );
}
